import { Col, Divider, Modal, Row, Space } from "antd";
import React from "react";
import Text from "../Text/Text";
import { numberFormatter } from "../../utility/Formatter";

interface Props {
  open: boolean;
  onClose: () => void;
  data: {
    label: string;
    labelEn?: string;
    value: string;
    percent: string;
    used?: string;
    remain?: string;
    subLabel?: string;
  }[];
  shopName: string;
  zone?: string;
  termPaymentType?: string;
  province?: string;
}

function ModalInfoCredit({
  open,
  onClose,
  data,
  shopName,
  zone,
  termPaymentType,
  province,
}: Props) {
  return (
    <Modal
      width={600}
      open={open}
      closable
      onCancel={onClose}
      title={
        <>
          <Text fontWeight={600} fontSize={20} color='Text2'>
            ข้อมูลวงเงินร้านค้า
          </Text>
          <br />
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            {shopName}&nbsp;|&nbsp;
          </Text>
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            เขต {zone} {province && `(${province})`}&nbsp;|&nbsp;
          </Text>
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            รูปแบบ {termPaymentType === "CREDIT" ? "เครดิต" : "เงินสด"}
          </Text>
        </>
      }
      centered
      footer={null}
    >
      <Divider />
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <Row justify='space-between' style={{ marginBottom: 2 }}>
            <Col>
              <Space size={2} direction='vertical'>
                <Text fontFamily='IBM Plex Sans Thai' fontSize={16} fontWeight={700}>
                  {item.label}
                </Text>
                <Text fontFamily='IBM Plex Sans Thai' fontSize={16} fontWeight={700}>
                  {item.labelEn}
                </Text>
                {item.used || item.remain ? (
                  <>
                    <Space size={8} direction='horizontal'>
                      {item.used && (
                        <Text fontFamily='IBM Plex Sans Thai' fontSize={14}>
                          ใช้แล้ว {numberFormatter(item.used, 2)}
                        </Text>
                      )}
                      <span style={{ margin: "0 8px", color: "#d9d9d9" }}>|</span>
                      {item.remain && (
                        <Text fontFamily='IBM Plex Sans Thai' fontSize={14}>
                          คงเหลือ {numberFormatter(item.remain, 2)}
                        </Text>
                      )}
                    </Space>
                  </>
                ) : null}
                {item.subLabel && (
                  <Text fontFamily='IBM Plex Sans Thai' fontSize={14}>
                    {item.subLabel}
                  </Text>
                )}
              </Space>
            </Col>
            <Col>
              <Text fontFamily='IBM Plex Sans Thai' fontSize={24} fontWeight={700}>
                {item.value}
              </Text>
            </Col>
          </Row>
          <Row justify='end' style={{ marginBottom: 2 }}>
            <Col>
              <Text fontFamily='IBM Plex Sans Thai' fontSize={16} fontWeight={400}>
                ({item.percent}%)
              </Text>
            </Col>
          </Row>
          {index !== data.length - 1 && <Divider style={{ margin: "4px 0" }} />}
        </React.Fragment>
      ))}
    </Modal>
  );
}

export default ModalInfoCredit;
